export default (permId, roleIds) =>
  new Promise((resolve, reject) => {
    window.axios
      .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}permissions/${permId}/roles`, {
        role_ids: roleIds,
      })
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
